
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/dashboard",
      function () {
        return require("private-next-pages/android/dashboard/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/dashboard"])
      });
    }
  